import styled from 'styled-components';
import {bordersStyles, typographyStyles} from '../../../../utils/styles';

const StyledInvoiceSelector = styled.div`
  ${bordersStyles.light};
  
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
`;

const StyledInvoiceSelectorBr = styled.div`
  text-align: center;
  
  &:before,&:after {
    background-color: ${props => props.theme.colors.neutral_4};
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: calc(100% / 2 - 15px);
  }
  &:before {
    right: 0.5em;
  }
  &:after {
    left: 0.5em;
  }
`;

const StyledInvoiceSelectorEmpty = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const StyledInvoiceSelectorEmptyText = styled.span`
  ${typographyStyles.heading.h5};
  color: ${props => props.theme.colors.neutral_10};
`;

const StyledInvoiceSelectorFormContainer = styled.div`
  color: ${props => props.theme.colors.neutral_8};
  display: flex;
  flex-direction: column;
  width: 100%;
  
  & > .ant-space {
    width: 100%;
    & > .ant-space-item {
      width: 100%;
    }
  }
`;

const StyledInvoiceSelectorFormContainerButtons = styled.div`
  text-align: center;
`;

export {
  StyledInvoiceSelector,
  StyledInvoiceSelectorBr,
  StyledInvoiceSelectorEmpty,
  StyledInvoiceSelectorEmptyText,
  StyledInvoiceSelectorFormContainer,
  StyledInvoiceSelectorFormContainerButtons,
};
